import {
  ConstrainMode,
  IColumn,
  SelectionMode,
  Shimmer,
  ShimmeredDetailsList,
  ShimmerElementType,
  Stack
} from "@fluentui/react";
import { Fragment } from "react";

interface TableShimmerProps {
  columns: Array<IColumn>;
}

export function TableShimmer({ columns }: TableShimmerProps): JSX.Element {
  return (
    <Fragment>
      <Stack tokens={{ childrenGap: 12 }} styles={{ root: { padding: 12 } }}>
        <Stack horizontal horizontalAlign="space-between">
          <Shimmer
            shimmerElements={[
              { type: ShimmerElementType.line, width: 80, height: 20 }
            ]}
          />
          <Shimmer
            shimmerElements={[
              { type: ShimmerElementType.line, width: 120, height: 32 }
            ]}
          />
        </Stack>
        <Shimmer
          shimmerElements={[
            { type: ShimmerElementType.line, width: "100%", height: 40 }
          ]}
        />
      </Stack>
      <ShimmeredDetailsList
        setKey="items"
        items={[]}
        columns={columns}
        ariaLabelForSelectionColumn="Toggle selection"
        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
        checkButtonAriaLabel="Row checkbox"
        constrainMode={ConstrainMode.horizontalConstrained}
        enableShimmer={true}
        selectionMode={SelectionMode.none}
      />
    </Fragment>
  );
}
